export default [
  {
    path: 'dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "admin" */ './Index.vue'),
    meta: {
      title: 'Home',
      icon: 'mdi-chart-areaspline',
    }
  }
];
